import React from 'react';
import cn from 'classnames';

import * as styles from './Description.module.scss';

export default function Description({ description, className }) {
  return (
    <div className={cn(styles.wrapper, className)}>
      <p className={styles.description}>{description}</p>
    </div>
  );
}
